// extracted by mini-css-extract-plugin
module.exports = {"infoSwitch":"x22BHnIOlrxSZGPwQjfYY","switchButton":"_2NopBYDXZCIGOwRFiI6Lo6","active":"_3piXSj4clrZCvvAaOEdTxm"};